<template>
  <form @submit.prevent="save()">
    <div class="form-group">
      <label for>Alerta*</label>
      <app-input-string
        v-model="bodyForm.custom_name"
        :maxlength="150"
      ></app-input-string>
      <app-small-form-errors :errors="errors.custom_name"></app-small-form-errors>
      <small class="form-text text-muted">
        Escribe una alerta personalizada para el cliente, por ejemplo: "No usar
        Penicilina".
      </small>
    </div>
    <app-button-submit :disabled="errors"></app-button-submit>
  </form>
</template>
<script>
import * as validate from "validate.js";
import { DentalClinicService } from "../../service.js";

const formRules = {
  custom_name: { presence: { message: "Requerido" } }
};

export default {
  name: "AlertForm",
  components: {
    //
  },

  // directives
  // filters

  props: {
    clientId: {}
  },

  data: () => ({
    bodyForm: {
      id: null,
      alert_id: null,
      custom_name: null,
      client_id: null
    }
  }),

  computed: {
    errors() {
      let err = validate(this.bodyForm, formRules, { fullMessages: false });
      return err ? err : false;
    }
  },

  mounted() {
    this.reset();
  },

  methods: {
    reset() {
      this.bodyForm.id = null;
      this.bodyForm.alert_id = null;
      this.bodyForm.custom_name = null;
      this.bodyForm.client_id = this.clientId || null;
    },
    setValue(reg) {
      this.bodyForm.id = reg.id || null;
      this.bodyForm.alert_id = reg.alert_id || null;
      this.bodyForm.custom_name = reg.custom_name;
      this.bodyForm.client_id = reg.client_id || this.clientId || null;
    },
    save() {
      DentalClinicService.saveClientAlert(this.bodyForm).then(() =>
        this.$emit("submitted")
      );
    }
  }
};
</script>
<style></style>
